/**
 * Global namespace for components `fixed-top` class.
 */
const fixedTopClass = "fixed-top";
export default fixedTopClass;
